import React from 'react';
import { styled } from '@mui/material';
import { Text } from './Text';
import { Colors } from 'library';

type EmptyTextPadding = 'none' | 'sm' | 'md';

interface EmptyTextProps {
    children: React.ReactNode;
    padding?: 'none' | 'sm' | 'md';
    dashedBorder?: boolean;
    backgroundColor?: string;
}

const PADDING_VALUE: Record<EmptyTextPadding, string> = {
    none: '0px',
    sm: '24px 0px',
    md: '48px 0px',
};

export function EmptyText({
    children,
    padding = 'md',
    dashedBorder = false,
    backgroundColor = 'none',
}: EmptyTextProps) {
    const paddingValue = PADDING_VALUE[padding];
    return (
        <Wrapper padding={paddingValue} dashedBorder={dashedBorder} backgroundColor={backgroundColor}>
            <Text component="p" tone="secondary" align="center">
                {children}
            </Text>
        </Wrapper>
    );
}

const Wrapper = styled('div')<{ padding: string; dashedBorder: boolean; backgroundColor: string }>(
    ({ padding, dashedBorder, backgroundColor }) => ({
        padding,
        backgroundColor,
        ...(dashedBorder && {
            border: `1px dashed ${Colors.border}`,
            borderRadius: 10,
        }),
    }),
);
